var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "withdrawal-details-ststus-wrapper",
      class: [_vm.$i18n.locale === "ar" ? "ar-style" : "", _vm.packageName],
    },
    [
      _c(
        "div",
        {
          staticClass: "custom-nav-block",
          style: `padding-top:${_vm.barHeight}px;`,
        },
        [
          _c("van-nav-bar", {
            staticClass: "van-bar",
            attrs: { title: "", "left-arrow": "" },
            on: { "click-left": _vm.goPrevious },
            scopedSlots: _vm._u([
              {
                key: "left",
                fn: function () {
                  return [
                    _c("img", {
                      staticClass: "left-nav",
                      attrs: {
                        src: require("@/assets/packageAssets/common/arrow05.png"),
                        alt: "",
                      },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "right",
                fn: function () {
                  return [
                    _vm.hasRefresh
                      ? _c(
                          "div",
                          {
                            staticClass: "refresh-wrapper",
                            on: { click: _vm.handleGetData },
                          },
                          [
                            _c("img", {
                              class: [_vm.isLoading ? "refresh" : ""],
                              attrs: {
                                src: require("@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/refresh.png"),
                                alt: "refresh",
                                width: "20",
                                height: "20",
                              },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "main" },
        [
          _vm.isLoading
            ? [
                _c(
                  "div",
                  { staticClass: "loading-wrapper" },
                  [_c("van-loading")],
                  1
                ),
              ]
            : [
                _c(
                  "div",
                  { staticClass: "status-wrapper" },
                  [
                    [0, 7, 8, 2, 5, 6].includes(_vm.info.state)
                      ? [
                          _vm.packageName === "kiko"
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/await.png"),
                                  alt: "icon",
                                  width: "44",
                                  height: "44",
                                },
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/await.png"),
                                  alt: "icon",
                                  width: "44",
                                  height: "44",
                                },
                              }),
                        ]
                      : [1, 4].includes(_vm.info.state)
                      ? [
                          _c("img", {
                            attrs: {
                              src: require("@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/error.png"),
                              alt: "icon",
                              width: "44",
                              height: "44",
                            },
                          }),
                        ]
                      : _vm.info.state === 3
                      ? [
                          _vm.packageName === "kiko"
                            ? _c("img", {
                                attrs: {
                                  src: require("@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/finish-kiko.png"),
                                  alt: "icon",
                                  width: "44",
                                  height: "44",
                                },
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/packageAssets/views/P1_Girls/WithdrawalDetails/vava/finish.png"),
                                  alt: "icon",
                                  width: "44",
                                  height: "44",
                                },
                              }),
                        ]
                      : void 0,
                    _c("p", { staticClass: "status-title" }, [
                      _vm._v(_vm._s(_vm.statusTextMap[_vm.info.state] || "-")),
                    ]),
                    _vm.info.remark
                      ? [
                          _c("p", { staticClass: "status-subtitle" }, [
                            _vm._v(_vm._s(_vm.info.remark)),
                          ]),
                        ]
                      : [
                          [3, 5, 6, 2, 7].includes(_vm.info.state)
                            ? [
                                _vm.info.withdrawalMethod === "Paypal"
                                  ? [
                                      _c(
                                        "p",
                                        { staticClass: "status-subtitle" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "lang.instantPayment.paypalPaymentInProgress"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "p",
                                        { staticClass: "status-subtitle" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "lang.instantPayment.paymentInProgress"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                              ]
                            : [1, 4].includes(_vm.info.state)
                            ? [
                                _vm.info.refuseType == 1
                                  ? [
                                      _c(
                                        "p",
                                        { staticClass: "status-subtitle" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "lang.instantPayment.error1"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm.info.refuseType == 2
                                  ? [
                                      _c(
                                        "p",
                                        { staticClass: "status-subtitle" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "lang.instantPayment.error2"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm.info.refuseType == 3
                                  ? [
                                      _c(
                                        "p",
                                        { staticClass: "status-subtitle" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "lang.instantPayment.error3"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm.info.refuseType == 4
                                  ? [
                                      _c(
                                        "p",
                                        { staticClass: "status-subtitle" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "lang.instantPayment.error4"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "p",
                                        { staticClass: "status-subtitle" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "lang.instantPayment.error5"
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                              ]
                            : [_c("p", { staticClass: "status-subtitle" })],
                        ],
                  ],
                  2
                ),
                _c("div", { staticClass: "info-wrapper" }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v(_vm._s(_vm.$t("lang.instantPayment.method"))),
                    ]),
                    _c("div", { staticClass: "item-value" }, [
                      _vm._v(_vm._s(_vm.info.withdrawalMethod || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v(_vm._s(_vm.$t("lang.instantPayment.amount"))),
                    ]),
                    _c("div", { staticClass: "item-value purple" }, [
                      _vm._v(
                        _vm._s(
                          _vm.info.applyAmount
                            ? `≈${_vm.info.currency} ${_vm.handleUSDollar(
                                _vm.info.applyAmount
                              )}`
                            : "-"
                        )
                      ),
                    ]),
                  ]),
                  _vm.info.feeRate
                    ? _c("div", { staticClass: "info-item" }, [
                        _c("div", { staticClass: "item-title" }, [
                          _vm._v(_vm._s(_vm.$t("lang.instantPayment.fee"))),
                        ]),
                        _c("div", { staticClass: "item-value purple" }, [
                          _vm._v(_vm._s(_vm.info.feeRate || "-")),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "info-item" }, [
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("lang.instantPayment.arrivalAmount"))
                      ),
                    ]),
                    _c("div", { staticClass: "item-value purple" }, [
                      _vm._v(
                        _vm._s(
                          _vm.info.arrivalAmount || _vm.info.arrivalAmount == 0
                            ? `≈${_vm.info.currency} ${_vm.handleUSDollar(
                                _vm.info.arrivalAmount
                              )}`
                            : "-"
                        )
                      ),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v(_vm._s(_vm.$t("lang.wd.phAccount"))),
                    ]),
                    _c("div", { staticClass: "item-value" }, [
                      _vm._v(_vm._s(_vm.info.accountId || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v(_vm._s(_vm.$t("lang.instantPayment.userId"))),
                    ]),
                    _c("div", { staticClass: "item-value" }, [
                      _vm._v(_vm._s(_vm.info.presentId || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("lang.instantPayment.withdrawalId"))
                      ),
                    ]),
                    _c("div", { staticClass: "item-value" }, [
                      _vm._v(_vm._s(_vm.info.withdrawId || "-")),
                    ]),
                  ]),
                  _c("div", { staticClass: "info-item" }, [
                    _c("div", { staticClass: "item-title" }, [
                      _vm._v(
                        _vm._s(_vm.$t("lang.instantPayment.submissionTime"))
                      ),
                    ]),
                    _c("div", { staticClass: "item-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm.info.submitTime
                            ? _vm.handleMoment(
                                _vm.info.submitTime,
                                "DD/MM/YYYY HH:mm:ss"
                              )
                            : "-"
                        )
                      ),
                    ]),
                  ]),
                  [1, 3, 4, 5, 6].includes(_vm.info.state) &&
                  _vm.info.dealWithTime
                    ? _c("div", { staticClass: "info-item" }, [
                        _c("div", { staticClass: "item-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("lang.instantPayment.reviewTime"))
                          ),
                        ]),
                        _c("div", { staticClass: "item-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.info.dealWithTime
                                ? _vm.handleMoment(
                                    _vm.info.dealWithTime,
                                    "DD/MM/YYYY HH:mm:ss"
                                  )
                                : "-"
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  [3, 5, 6].includes(_vm.info.state) && _vm.info.paymentTime
                    ? _c("div", { staticClass: "info-item" }, [
                        _c("div", { staticClass: "item-title" }, [
                          _vm._v(
                            _vm._s(_vm.$t("lang.instantPayment.paymentTime"))
                          ),
                        ]),
                        _c("div", { staticClass: "item-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.info.paymentTime
                                ? _vm.handleMoment(
                                    _vm.info.paymentTime,
                                    "DD/MM/YYYY HH:mm:ss"
                                  )
                                : "-"
                            )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ]),
              ],
        ],
        2
      ),
      _c("div", { staticStyle: { width: "100%", height: "100px" } }),
      _vm.info && _vm.info.refuseType == 1
        ? _c(
            "div",
            {
              staticClass: "change-btn",
              style: { "margin-bottom": `${_vm.bottomBarHeight}px` },
              on: { click: _vm.handleToAccountEdit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("lang.commonM.k082")) + " ")]
          )
        : _vm._e(),
      _c("WaterMark", { attrs: { text: _vm.localTime } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }